import styled from 'styled-components';

export const Buttons = styled.div`
  a + a,
  button + button {
    margin-left: 20px;
  }
`;
